import React from "react";

const ToggleSwitch = ({ checked, onChange, name }) => {
  return (
    <label className="inline-flex items-center cursor-pointer relative">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        name={name}
        className="invisible absolute"
      />
      <div className="relative">
        <div
          className={`block bg-bkg2 w-14 h-8 rounded-full ${
            checked ? "bg-primary/60 " : ""
          }`}
        ></div>
        <div
          className={`absolute left-1 top-1 bg-text-gen w-6 h-6 rounded-full transition-transform ${
            checked ? "translate-x-full" : ""
          }`}
        ></div>
      </div>
    </label>
  );
};

export default ToggleSwitch;
